<template>
    <div class="lw-cols one-row one-row-tl one-row-tp multiple-rows-sl multiple-rows-sp main">
        <div class="col flex-item span_10_of_12 span_10_of_12-tl span_10_of_12-tp span_12_of_12-sl span_12_of_12-sp lw-padding-small">
            <div class="lw-cols one-row one-row-tl one-row-tp one-row-sl one-row-sp js-same-content-wrapper">
                <div class="col flex-item span_3_of_12-all no-padding js-same-content-child lw-br-1px-fadeout80" v-if="coursesVisibility">
                    <div class="learnworlds-main-text  learnworlds-element learnworlds-main-text-very-large">{{userStats.courseCount}}</div>
                    <div class="learnworlds-overline-text learnworlds-element">
                        {{$t('common.courses')}}
                    </div>
                </div>
                <div class="col flex-item span_3_of_12-all no-padding js-same-content-child lw-br-1px-fadeout80" v-if="hoursVisibility">
                    <div class="learnworlds-main-text learnworlds-element learnworlds-main-text-very-large">{{userStats.learningHours}}</div>
                    <div class="learnworlds-overline-text learnworlds-element" >
                        {{$t('common.hours')}}
                    </div>
                </div>
                <div class="col flex-item span_3_of_12-all no-padding js-same-content-child lw-br-1px-fadeout80" v-if="postsVisibility">
                    <div class="learnworlds-main-text  learnworlds-element learnworlds-main-text-very-large">{{userStats.postsCount}}</div>
                    <div class="learnworlds-overline-text learnworlds-element">
                        {{$t('profile.posts')}}
                    </div>
                </div>
                <div class="col flex-item span_3_of_12-all no-padding js-same-content-child" v-if="certificatesVisibility">
                    <div class="learnworlds-main-text  learnworlds-element learnworlds-main-text-very-large">{{userStats.certificatesCount}}</div>
                    <div class="learnworlds-overline-text learnworlds-element">
                        {{$t('course.certificates')}}
                    </div>
                </div>
            </div>
        </div>

        <div class="col flex-item span_2_of_12 span_2_of_12-tl span_2_of_12-tp span_12_of_12-sl span_12_of_12-sp lw-padding-small lw-body-bg" v-if="messagesVisibility">
            <div class="lw-cols one-row one-row-tl one-row-tp one-row-sl one-row-sp js-same-content-wrapper" >
                <div class="col flex-item span_12_of_12-all no-padding js-same-content-child" @click="navigateToInbox">
                    <div class="learnworlds-main-text-very-large learnworlds-main-text learnworlds-icon far fas fa-envelope"></div>
                    <div class="learnworlds-overline-text learnworlds-element" >
                        {{userStats.messageCount}} {{$t('profile.messages')}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ComponentTemplatesMixin from "../../mixins/ComponentTemplatesMixin";

    export default {
        name: "UserStatsLayout1",
        mixins: [
            ComponentTemplatesMixin
        ],
        props: {
            userStats: {
                type: Object,
                required: true,
            },
            coursesVisibility: {
                type: Boolean,
                default: true
            },
            hoursVisibility: {
                type: Boolean,
                default: true
            },
            postsVisibility: {
                type: Boolean,
                default: true
            },
            certificatesVisibility: {
                type: Boolean,
                default: true
            },
            messagesVisibility: {
                type: Boolean,
                default: true
            },
        },
        methods: {
            navigateToInbox () {
                this.emitAction('navigate-to-inbox');
            }
        }
    }
</script>
